import React from "react";
import "../scss/header.scss";

const Header = ({children}) => <header className="header">{children}</header>;

Header.Title = ({children}) => <h2 className="header-title">{children}</h2>;
Header.Subtitle = ({children}) => <h6 className="header-subtitle">{children}</h6>;

export default Header;